import React from 'react';
import "./App.css";
import Contact from "./Components/Contact/JavaScript/Contact";
import Introduction from "./Components/Introduction/JavaScript/Introduction";
import Projects from "./Components/Projects/JavaScript/Projects";
import Technologies from "./Components/Technologies/JavaScript/Technologies";

function App() {
    return (
        <div className="app">
            <Introduction />
            <Technologies />
            <Projects />
            <Contact />
        </div>
    );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js